import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    maxWidth: "1000px !important"
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));

interface modalProps {
  onClose?: (e: any) => void;
  open: boolean;
  setOpen: (arg0: boolean) => void;
  children: any;
  fullWidth?: boolean;
  className?: string;
  id?: string;
  sx?: any;
}

const Modal: React.FC<modalProps> = ({
  open = false,
  setOpen = () => {},
  onClose = (e) => {},
  children = "",
  fullWidth = false,
  className = "",
  id = "",
  sx = {}
}) => {
  const handleClose = (e: any) => {
    setOpen(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={fullWidth}
        className={className}
        id={id}
        sx={sx}
      >
        {children}
      </BootstrapDialog>
    </div>
  );
};
export default Modal;
